import type { RouteObject } from "react-router";
import UsersListPage from "@/src/users/pages/users-list-page";

export const usersRoutes: RouteObject[] = [{ path: "/users", element: <UsersListPage /> }];
